<div class="coupon-app container-fluid">
  <div class="header" *ngIf="!isInIframe()">
    <div class="header-logo w-100">
      <img [src]="logoSrc()" [alt]="banner() + ' logo'" />
    </div>
    <div class="header-register">
      <ng-container>
        <div class="header-text" (click)="!!user() ? logout() : login()">
          <div class="header-title">Hi {{ userName() }}</div>
          <div class="header-subtitle">{{ getLoginText() }}</div>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-container *ngIf="isLoading()">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span></div
  ></ng-container>
  <div class="container" *ngIf="!isLoading()">
    <ng-container>
      <div *ngIf="couponAuth.setToken$ | async; else showLoader">
        <app-social-offers-list (doLogin)="login()"></app-social-offers-list>
      </div>
    </ng-container>
    <ng-template #showLoader>
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </ng-template>
  </div>
</div>
